<template>
    <li>
        <div class="answer-checkbox">
            <div class="answer-checkbox-container">
                <div 
                :class="{'white-checkbox': !isSelected,
                        'purple-checkbox': isSelected,
                        'cursor-pointer': !isDisable
                }"
                class="answer-checkbox-rectangle">
                    <img 
                    v-if="isSelected"
                    src="@/assets/images/congress1/answerCheckMark.svg" alt="check mark">
                </div>
            </div>

            <div
                v-html="answerText"
                :class="{'cursor-pointer': !isDisable}"
                class="answer-checkbox-text">                
            </div>
      </div>
    </li>
</template>

<script>
export default {
    name: 'UniversalAnswerCheckbox',
    props: {
        isSelected: Boolean,
        isDisable: Boolean,
        answerText: String
    }
}

</script>

<style>
    
</style>